export const useDictionary = (_needUpdate: boolean = false) => {
  const { dictionaryMap, updateDictionaryList } = useGlobalStore((state) => state)
  // platform：静态字典本地加载，不再请求 /dictionary/*
  useEffect(() => {
    if (Object.keys(dictionaryMap).length === 0) {
      updateDictionaryList()
    }
  }, [dictionaryMap, updateDictionaryList])
  return { dictionaryMap }
}
